import { useLocale } from 'src/lib/hooks/useLocal'

const BulkPGUpdateDialog = () => {
  const { t } = useLocale()
  return (
    <>
      <div className='flex flex-col gap-2'>
        <h2 className='text-base font-semibold text-carbon'> {t('payment.warning')}</h2>
        <p className='text-sm text-coal-dark leading-[22px]'>
          {t('payment.warning_description')}
          <span className='font-medium text-carbon'>{t('payment.warning_bold')}</span>
          &nbsp;{t('payment.warning_bold_description')}. {t('payment.are_you_sure')}
        </p>
      </div>
    </>
  )
}

export default BulkPGUpdateDialog
